

















import { defineComponent, ref } from "@nuxtjs/composition-api";

import LazyHydrate from "vue-lazy-hydration";

export default defineComponent({
  name: "ProductTab",
  props: {
    title: {
      type: String,
    },
    identifier: {
      type: String,
      default: "",
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LazyHydrate,
  },
  setup() {
    const isActive = ref(false);

    const toggle = () => {
      isActive.value = !isActive.value;
    };

    return {
      isActive,
      toggle,
    };
  },
});
